module.exports = __webpack_public_path__ + "static/img/4areaB_8.2e52eb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_8.png
// module id = 1188
// module chunks = 1